import {rolesList, RolesList} from './rolesList'
import keycloak from '../keycloak';
import {parseJwt} from "../utils";

export default class Roles {
  static hasAccess(accessName: keyof RolesList) {
    const userRoles = Roles.getUserRoles()
    return Roles.isRolesInAccess(accessName, userRoles)
  }

  static isRolesInAccess(access: keyof RolesList, userRoles: string[]) {
    if (rolesList.hasOwnProperty(access)) {
      const accessRoles = rolesList[access]
      const intersection = accessRoles.filter((x: string) => userRoles.includes(x));
      return intersection.length > 0
    }

    return false
  }

  static getUserRoles()  {
    const tokenData = parseJwt(keycloak.token || '')

    return tokenData.roles || []
  }
}
